import script from "./ResumeSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumeSection.vue?vue&type=script&setup=true&lang=js"

import "./ResumeSection.vue?vue&type=style&index=0&id=7b3862a7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b3862a7"]])

export default __exports__